var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_253_15546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 38C10 22.536 22.536 10 38 10C53.464 10 66 22.536 66 38C66 53.464 53.464 66 38 66C22.536 66 10 53.464 10 38Z",
    fill: "#448AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6004 29.2999C38.6004 29.0612 38.5056 28.8323 38.3368 28.6635C38.168 28.4947 37.9391 28.3999 37.7004 28.3999C37.4617 28.3999 37.2328 28.4947 37.064 28.6635C36.8952 28.8323 36.8004 29.0612 36.8004 29.2999V36.7999H29.3004C29.0617 36.7999 28.8328 36.8947 28.664 37.0635C28.4952 37.2323 28.4004 37.4612 28.4004 37.6999C28.4004 37.9386 28.4952 38.1675 28.664 38.3363C28.8328 38.5051 29.0617 38.5999 29.3004 38.5999H36.8004V46.0999C36.8004 46.3386 36.8952 46.5675 37.064 46.7363C37.2328 46.9051 37.4617 46.9999 37.7004 46.9999C37.9391 46.9999 38.168 46.9051 38.3368 46.7363C38.5056 46.5675 38.6004 46.3386 38.6004 46.0999V38.5999H46.1004C46.3391 38.5999 46.568 38.5051 46.7368 38.3363C46.9056 38.1675 47.0004 37.9386 47.0004 37.6999C47.0004 37.4612 46.9056 37.2323 46.7368 37.0635C46.568 36.8947 46.3391 36.7999 46.1004 36.7999H38.6004V29.2999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_253_15546",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_253_15546"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_253_15546",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.e0808a96c7ecaa8ad647cac45a69c331.svg";
export { ForwardRef as ReactComponent };